import React from 'react'

export default function Gap({size}) {
  return (
    <div style={{height: size}}></div>
  )
}
